import {signUrl} from './UrlSignatureModule';

export const buildCsvDownloadUrl = (query, filters) => {

    const url = __API__ +
        `/api/ui/areacontrol/csv?search=${query}&stockStatus=${filters.stockStatus}&refillStatus=${filters.refillStatus}&replenishmentStatus=${filters.replenishmentStatus}&modules=${filters.modulesSelected}&propertyToSortBy=id&sortDirection=ASC`;

    return signUrl(url);
};

export const buildDashboardCsvDownloadUrl = (storeGln, moduleName) => {

    const url = __API__ +
            `/api/ui/areacontrol/csv?search=${storeGln}&stockStatus=ALL&replenishmentStatus=ALL&modules=${moduleName}&propertyToSortBy=id&sortDirection=ASC`;

    return signUrl(url);
};



// WEBPACK FOOTER //
// ./src/admin/services/AreaControlModule.js